import { Point } from "appworks/utils/geom/point";
import { ValueList } from "appworks/utils/value-list";
import { SymbolConfig, SymbolDefinition } from "slotworks/model/symbol-definition";

class SlotDefinition {
    public reelsets: Map<string, string[][]>;

    public lines: ValueList<Point[]> = new ValueList();

    public matrixGrid: number[];

    public symbolDefinitions: SymbolDefinition[];

    public bestSymbol: SymbolDefinition;

    private highestSymbolPayout: number = 0;

    public getSymbolDefinition(id: string): SymbolDefinition {
        for (const symbol of this.symbolDefinitions) {
            if (symbol.id === id || symbol.aliases.indexOf(id) > -1) {
                return symbol;
            }
        }
        throw new Error("Symbol not found in symbol definitions: " + id);
    }

    public processReelSets(reelsets: { [id: string]: number[][] }) {
        this.reelsets = new Map<string, string[][]>();

        for (const reelsetId in reelsets) {

            if (reelsets.hasOwnProperty(reelsetId)) {
                const reelset = reelsets[reelsetId];

                const parsedReelset = [];

                for (const reel of reelset) {

                    const parsedReel: string[] = [];
                    parsedReelset.push(parsedReel);

                    for (const symbolId of reel) {
                        parsedReel.push(this.symbolDefinitions[symbolId].id);
                    }
                }

                this.reelsets.set(reelsetId, parsedReelset);
            }
        }
    }

    public processSymbols(symbols: SymbolConfig[]) {
        this.symbolDefinitions = [];
        this.bestSymbol = null;
        this.highestSymbolPayout = 0;

        let index = 0;
        for (const symbol of symbols) {
            const symbolDef = new SymbolDefinition({ ...symbol, index: index++ });
            this.symbolDefinitions.push(symbolDef);

            // Helpfully keep a reference to the highest paying symbol
            if (symbolDef.payouts && !symbol.scatter) {
                symbolDef.payouts.forEach((value: number) => {
                    if (value > this.highestSymbolPayout) {
                        this.highestSymbolPayout = value;
                        this.bestSymbol = symbolDef;
                    }
                });
            }
        }
    }
}

export const slotDefinition = new SlotDefinition();
